import React, { useState } from 'react';
import { AuditRecord } from '../../../types';
import { exportAuditToJSON, exportAuditToCSV } from '../../../services/auditService';

interface Props {
  auditRecords: AuditRecord[];
  onClearAll: () => void;
  btnStyle: (active: boolean) => React.CSSProperties;
}

export function AuditExportActions({ auditRecords, onClearAll, btnStyle }: Props) {
  const [confirmClear, setConfirmClear] = useState(false);

  const downloadCSV = () => {
    const blob = new Blob([exportAuditToCSV(auditRecords)], { type: 'text/csv' });
    const a = document.createElement('a'); a.href = URL.createObjectURL(blob);
    a.download = `mer-audit-${Date.now()}.csv`; a.click();
  };

  const downloadJSON = () => {
    const blob = new Blob([exportAuditToJSON(auditRecords)], { type: 'application/json' });
    const a = document.createElement('a'); a.href = URL.createObjectURL(blob);
    a.download = `mer-audit-${Date.now()}.json`; a.click();
  };

  return (
    <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
      <span style={{ fontSize: 10, color: 'var(--t3)' }}>{auditRecords.length} total</span>
      <button onClick={downloadCSV} style={{ ...btnStyle(false), fontSize: 10 }}>↓ CSV</button>
      <button onClick={downloadJSON} style={{ ...btnStyle(false), fontSize: 10 }}>↓ JSON</button>
      {!confirmClear
        ? <button onClick={() => setConfirmClear(true)} style={{ ...btnStyle(false), fontSize: 10, color: 'var(--red)' }}>Clear All</button>
        : <>
            <button onClick={() => { onClearAll(); setConfirmClear(false); }}
              style={{ ...btnStyle(false), fontSize: 10, color: 'var(--red)', borderColor: 'var(--red)' }}>Confirm</button>
            <button onClick={() => setConfirmClear(false)} style={{ ...btnStyle(false), fontSize: 10 }}>Cancel</button>
          </>
      }
    </div>
  );
}
